import { IconCamera } from "@/Components/Icon";
import ElementLoader from "@/Components/Media/ElementLoader";
import type { IWebCOOSElement } from "@/services/assets/types";
import { utils } from "@axdspub/axiom-ui-utilities";
import { type ReactElement, type ReactNode, useState } from "react";


export const AnnotatedImageLoader = (
    {annotated_image_reference,
        imageClassName,
        imageErrorClassName
    }:
    {annotated_image_reference: string, imageClassName?: string, imageErrorClassName?: string}
): ReactElement => {

    return <ElementLoader elementIdentifier={annotated_image_reference} View={({element}:{element:IWebCOOSElement}): ReactElement => {
        return <ImageLoader
                                url={element.data.properties.url}
                        className={imageClassName}
                        errorClassName={imageErrorClassName}
        />


    }}
/>; 
}

const ImageLoader = ({
    url,
    label,
    width,
    height,
    className = '',
    ErrorMessage,
    defaultErrorClassName = 'bg-gray-100 rounded shadow flex items-center justify-center border-2 border-dashed border-gray-300',
    errorClassName,
    Overlay,
    ...props
}: {
    url?: string | Array<string | null | undefined>;
    label?: string;
    width?: number;
    height?: number
    className?: string;
    defaultErrorClassName?: string;
    errorClassName?: string;
    ErrorMessage?: ReactNode;
    Overlay?: ReactNode;
} & React.ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
    const urlsToTry = (Array.isArray(url) ? url : (url ? [url] : [])).filter(u => u !== null && u !== undefined && String(u).match(/\.jpg\/|\.jpeg\/|jpg$|jpeg$|png$|gif$|webp$|bmp$|svg$/)) as string[];
    const [errorLoading, setErrorLoading] = useState(!urlsToTry.length)
    const [loaded, setLoaded] = useState(false);
    const [urlIndex, setUrlIndex] = useState(0);
    return <>
        {urlsToTry[urlIndex] && (
            <img
                src={urlsToTry[urlIndex]}
                alt={label ?? ''}
                width={width}
                height={height}
                className={`${className} ${errorLoading ? 'hidden' : ''}`}
                onError={(e) => {
                    // If rect_small fails, try square_small as fallback
                    const nextIndex = urlIndex + 1;
                    if (nextIndex < urlsToTry.length) {
                        setUrlIndex(nextIndex);
                        const nextUrl = urlsToTry[nextIndex];
                        const img = e.target as HTMLImageElement;
                        img.src = nextUrl;

                    } else {
                        // If both fail, hide the image and show placeholder
                        setErrorLoading(true);
                    }
                }}
                onLoad={() => {
                    setLoaded(true)
                }}
                {...props}
            />
        )}
        {
            Overlay && loaded && !errorLoading &&
            <div className='absolute top-0 left-0 w-full h-full group'>
                {Overlay}
            </div>
        }
        {
            errorLoading &&
            <div
                className={utils.makeClassName({
                    defaultClassName: defaultErrorClassName,
                    className: errorClassName
                })}
            >
                <div className='text-center text-gray-500 text-xs px-2'>
                    {ErrorMessage ?? <>
                        <div className='flex flex-row justify-center items-center gap-2'>
                            <IconCamera size={4} extraClasses='mx-auto' paddingx={0} />
                            <div className='font-medium'>No preview image</div>
                        </div>
                        <div className='text-gray-400'>available</div>
                    </>}
                </div>
            </div>
        }
    </>

}

export default ImageLoader